<template>
  <div class="panel">
    <div class="panel-heading">{{heading}}</div>
    <div class="panel-body">
      <canvas ref="chart" :style="{height: '150px', width:'800px'}"></canvas>
    </div>
    <div class="duration-select-row">
      <v-select :style="{'margin-right':'20px'}"
                :items="durationSelectItems"
                item-text="label"
                item-value="duration"
                label="Bond Duration 1"
                dense
                solo
                @change="onDuration1Change"></v-select>

      <v-select :items="durationSelectItems"
                item-text="label"
                item-value="duration"
                label="Bond Duration 2"
                dense
                solo
                @change="onDuration2Change"></v-select>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import * as data from '../../../client/src/data.js'
  export default {
    props: {
      allYields: Array,
    },
    data() {
      return {
        chart: null,
        duration1: 360,
        duration2: 120,
        durationSelectItems: data.LONG_DURATION_LABELS.map(label => ({label: label[1], duration: label[0]})),
        options: {
          animation: false,
          maintainAspectRatio: false,
          hover: {
            intersect: false,
            mode: 'index'
          },
          tooltips: {
            enabled: false
          },
          legend: {
            display: false
          },
          elements: {
            point: {
              radius: 0
            }
          },
          scales: {
            xAxes: [{
              type: 'time',
              ticks: {
                autoSkip: true,
                maxTicksLimit: 20
              },
              time: {
                unit: 'year'
              }
            }],
            yAxes: [{
              ticks: {
                callback: value => value.toFixed(1) + '%'
              }
            }]
          }
        }
      };
    },
    watch: {
      allYields() {
        this.drawChart();
      },
      duration1() {
        this.drawChart();
      },
      duration2 () {
        this.drawChart();
      }
    },
    computed: {
      heading() {
        if (!this.allYields) return '';

        return data.getShortDurationLabel(this.duration1) + ' - ' +
          data.getShortDurationLabel(this.duration2) + ' Treasury bond spread';
      }
    },
    methods: {
      onDuration1Change(value) {
        this.duration1 = value;
      },
      onDuration2Change(value) {
        this.duration2 = value;
      },
      drawChart() {
        if (!this.allYields) return;

        const spreads = data.getYieldSpreads(this.duration1, this.duration2);

        this.chart = new Chart(this.$refs.chart, {
          type: 'line',

          data: {
            datasets: [{
              data: spreads,
              borderColor: '#4A87D0',
              borderWidth: '2',
              backgroundOpacity: '.3',
              backgroundColor: 'rgba(74,135,208, .5)'
            }]
          },
          options: this.options
        });
      }
    }
  }
</script>

<style>
  .duration-select-row {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

</style>
